export default {
    newDesign: true,
    parameters: {
        landing_id: "TrQMIm",
        segment: 12,
    },
    downtimeUrl: "https://www.kodland.org/tr",
    title: "Matematik, bir çocuk için en temel beceridir | Kodland",
    stopPage: {
        image: "/welcome/quizV2/no-computer.png",
        title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz!",
        subtitle:
            "Maalesef tabletler veya telefonlar derslerimizi almak için uygun değil. Bir dahaki sefere sizi sınıflarımızda görmekten mutluluk duyarız!",
    },
    quizRotateBySteps: {
        1: {
            type: "age-start",
            title: "Çocuğunuzun yaşı kaç?",
            image: {
                url: "/welcome/tr_math_start_desk.png",
            },
            imageMobile: {
                url: "/welcome/tr_math_start_mob.png",
            },
        },
        2: {
            question: "Çocuğun matematik, mantık veya aritmetik öğrenme deneyimi var mı?",
            subtitle: "Kadın öğretmen: Çocuğunuza matematiği nasıl öğreteceğinizi öğrenin",
            answers: [
                {
                    answer: "🏫 Evet, okulda eğitim aldı",
                    distribution_tag_question: [48],
                },
                {
                    answer: "🧒 Evet, kendi başına veya ebeveynlerle eğitim aldı",
                    distribution_tag_question: [48],
                },
                {
                    answer: "👩‍🎓 Evet, kurslarda/çocuk branşlarında eğitim aldı",
                    distribution_tag_question: [48],
                },
                {
                    answer: "😊 Hayır, deneyimi yok",
                    distribution_tag_question: [48],
                },
            ],
        },
        3: {
            question: "Çocuğunuz daha önce online ders aldı mı?",
            answers: [
                "✅ Evet, düzenli aldı",
                "🙂 Evet, kısa süreli aldı",
                "😌 Hayır, hiç almadı",
            ],
        },
        4: {
            question: "Çocuğunuzun eğitimi için aylık hangi bütçe uygundur?",
            financial: true,
            answers: [
                "💵 ₺1.000’e kadar",
                "💳 ₺1.000–2.000",
                "💰 ₺2.000–3.500",
                "🤑 ₺3.500 üzeri",
            ],
        },
        5: {
            question: "Çocuğunuzun ders dışı aktivitelerine aylık ne kadar harcıyordunuz?",
            answers: [
                "🚫 Harcama yapmadım",
                "💵 ₺500–1.500",
                "💳 ₺1.500–3.000",
                "💰 ₺3.000’den fazla"
            ],
        },
        6: {
            question: "Çocuğunuza deneme matematik dersi önerirseniz nasıl tepki verir?",
            answers: [
                "🤩 İlgi gösterir",
                "🤔 Kararsız ama dener",
                "⚽ Başka aktiviteleri tercih eder",
                "❌ İstemediğini söyler"
            ]
        },
        7: {
            question:
                "Çocuğunuzun eğitim için bilgisayar veya laptopu var mı?",
            answers: [
                "👍 Evet",
                {
                    answer: "👎 Hayır",
                    stopAnswer: true,
                },
            ],
        },
        8: {
            title: "Son bir adım kaldı 🎉",
            typeInfo: "congrats",
            subtitle:
                "Çocuğunuzun mantıksal düşünme becerisini ve matematikte özgüvenini geliştirmesine yardımcı olun!",
            button: "📅 Bir ders planlayın",
        },
        9: {
            title: "Ücretsiz derse kaydolun",
            type: "one-page-contacts",
            subtitle: "Birbirimizi tanıyalım, ne öğreneceğimizi ve derslerin nasıl yapılacağını öğrenelim.",
            button: "Neredeyse bitti 🔥",
        },
        10: {
            title: "",
            type: "timeslot",
            subtitle: "",
            button: "",
        },
        11: {
            title:
                "Kaydı tamamlamak için bu bilgileri inceleyin ✨",
            typeInfo: "pc-laptop",
            subtitle:
                "Derse katılmak için lütfen masaüstü veya dizüstü bilgisayar kullanın ve ders boyunca çocuğunuza eşlik etmeyi unutmayın. Deneme dersinin bireysel ve kişiye özel olduğunu hatırlatmak isteriz.",
            button: "Başka neler var?",
        },
        12: {
            title: "Deneme dersinizden önce e-posta ve WhatsApp üzerinden iletişimde kalacağız. 📞",
            typeInfo: "whatsapp",
            subtitle:
                "Dersinizden 24 saat önce bir hatırlatma göndereceğiz ve 2 saat öncesinde katılımınızı onaylamanızı isteyeceğiz. İletişim kurmamız, dersinizin planlandığı gibi gerçekleşmesi için önemlidir.",
            button: "Başka neler var?",
        },
        13: {
            title: "Ders platformumuzda gerçekleşecek 💻",
            typeInfo: "classroom",
            subtitle:
              "WhatsApp ve e-posta yoluyla bir bağlantı ve özel bir kod alacaksınız. Sadece bağlantıya tıklayın, doğrudan derse yönlendirileceksiniz. Ekstra uygulama veya indirme gerekmiyor.",
            button: "Anladım ✅",
        }
    },
};